import { Component } from "@angular/core"
import { ViewController, NavParams, LoadingController, AlertController, ModalController } from "ionic-angular"

import { UserService } from "../../services/user"
import { EventService } from "../../services/event"
import { UserPickListPage } from "../users/pick-list"

@Component({
  selector: "event-release-page",
  templateUrl: "release.html",
})
export class EventReleasePage {

  event: any = {}
  comments = ""
  users = []

  constructor(
    private navParams: NavParams,
    private viewCtrl: ViewController,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private modalCtrl: ModalController
  ) {

    this.event = this.navParams.get("event")
  }

  onExit() {

    this.viewCtrl.dismiss()
  }

  onSuggestProfessionals() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((users) => {

      if (users)
        this.showUserPickListPage(users)
    })

    loading.present()

    UserService.getSectorUsers(this.event.sector._id)
      .then((users) => {

        loading.dismiss(users)
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao obter profissionais",
          buttons: ["Ok"]
        }).present()
      })
  }

  showUserPickListPage(users) {

      const options = { title: "Selecionar profissionais", pickMultiple: true }
      const modal = this.modalCtrl.create(UserPickListPage, { users, options })

      modal.onDidDismiss((users) => {

        if (!users)
          return

        users.forEach((user) => user.isLoadingPicture = true)

        this.users = users
      })

      modal.present()
  }

  suggestLabel() {

    return this.users.length == 1 ? "Sugerir o seguinte profissional" : "Sugerir os seguintes profissionais"
  }

  onConfirm() {

    const loading = this.loadingCtrl.create({ content: "Por favor, aguarde..." })

    loading.onDidDismiss((data) => {

      if (data)
        this.viewCtrl.dismiss(data)
    })

    loading.present()

    EventService.releaseEvent(this.event, this.comments, this.users)
      .then((event) => {

        loading.dismiss({ released: true, event })
      })
      .catch((error) => {

        console.log(error)

        loading.dismiss()

        this.alertCtrl.create({
          message: "Falha ao liberar evento",
          buttons: ["Ok"]
        }).present()
      })
  }
}



// WEBPACK FOOTER //
// ./src/pages/events/release.ts